/*Package importing*/
import React, { Component } from 'react';
import $ from 'jquery';

/*Components*/
import Input from '../../components/formComponents/input';
import Textarea from '../../components/formComponents/textarea';
import SelectBox from '../../components/formComponents/selectBox';
import ImageUploader from '../../components/common/imageUploader';
import CheckBox from '../../components/formComponents/checkbox';

/*Services*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';
import APIGet from '../../services/apiCall/get';
import EmailValidation from '../../services/validation/email';
import PhoneValidation from '../../services/validation/phone';


/*Assets*/


class SignupTab2 extends Component {
  constructor(props){
    super(props);
    this.state = {
      category: null,
      apiLoading: true,
      categorySelected: [],
      showUploadLoader: false,
      feedback: "",
      error: "",
      termsCheck: false,
      locationOptions: [],
      newLocationOptions: [],
      newLocation:null
    }
  }

  componentDidMount() {
    this.getCategory();
    this.getLocations();
  }

  getCategory(){
    var url = devconfig.vendor+'category/all-list';
    if(this.props.type != 1){
      url = devconfig.localVendor + 'department/list'
    }
    APIGet(url).then(function(response){
      if(response.status == "ok"){
        this.setState({ category: response.data, apiLoading: false});
      }
      else {
        this.setState({apiLoading: false});
      }
    }.bind(this))
  }

  async search(query){
    this.setState({locationSearch: query});
    if(query && query.length){
      let url = devconfig.localVendor + "location/search";
      let data = JSON.stringify({
        "text" : query
      })
      APIPost(url, data).then(function(response){
        if(response.status==="ok"){
          this.setState({newLocationOptions: response.data});
        }
        else{
          this.setState({ error: response.message});
        }
      }.bind(this));
    }
    else{
      this.setState({newLocationOptions: []});
    }
  }

  getLocations(){
    var url = devconfig.localVendor+'location/list';
    if(this.props.type!=1){
      APIGet(url).then(function(response){
        if(response.status == "ok"){
          let temp = [];
          response.data.forEach(element => {
            let loc = element.name
            const x = element.name.search(",");
            if (x != -1) {
              loc = element.name.slice(0, x)
            }
            temp.push({value: element.id, label: loc});
          });
          temp.push({ value: 0, label: "Others" });
          this.setState({locationOptions: temp});
        }
        else {
          this.setState({apiLoading: false});
        }
      }.bind(this))
    }
  }


  certificateUploaded(tempURL){
    this.setState({certificate: tempURL, showUploadLoader: false});
  }

  triggerClick(tempItem, tempLoader){
    $(tempItem).trigger('click');
  }

  selectchange(tempVal){
    this.setState({feedback: tempVal.label});
    
  }

async buttonClick(){
  var tempEmail = await EmailValidation(this.state.mail);
  var tempPhone = await PhoneValidation(this.state.phone);

  if(!tempEmail){
    this.setState({error: "Invalid Email Address"});
  }
  else if(!tempPhone){
    this.setState({error: "Invalid Phone Number"});
  }
  else{
    var tempData= {
      name: this.state.name,
      mail: this.state.mail,
      phone: this.state.phone,
      category: this.state.categorySelected,
      gst: this.state.gst,
      locality: this.state.locality,
      document_url: this.state.certificate,
      address: this.state.address,
      feedback: this.state.feedback,
      newLocation: this.state.newLocation
    }
    this.props.success(tempData)
  }
}

toggleCheckbox(){
  this.setState({termsCheck: !this.state.termsCheck});
}

  render() {
    const options = [
      { value: 1, label: 'Through Social media' },
      { value: 2, label: 'Website' },
      { value: 3, label: 'Google' },
      { value: 4, label: 'Advertisement' },
      { value: 5, label: 'Other' },
    ]

    if(this.state.apiLoading){
      return(
        null
      )
    }
    return (
      <div className="col-sm-10 col-11 mx-auto e-outer-wrap p-5">
        <div className="row">
          <div  className="col-lg-12">
            <h5>What type of seller are you?</h5>
          </div>
        </div>
        <div className="row pt-3">
          <div className="col-md-6 ">
            <label>Company Name</label>
            <Input id="e-company-name" value={this.state.name} type="text" className="e-profile-edit" valueChange={(e) => {this.setState({name: e}) }}/>
          </div>
          <div className="col-md-6">
            <label>Email Address</label>
            <Input id="e-mail" value={this.state.mail} type="text" className="e-profile-edit" valueChange={(e) => {this.setState({mail: e}) }}/>
          </div>
        </div>
        <div className="row">

          <div className="col-lg-12 mt-4">
            <label className="mb-0 pb-0">Choose your business category</label>
          </div>
          {
            this.state.category.map((item,index) => {
              return(
                <div className="col-sm-6 pt-2 mb-3">
                  <div className= {$.inArray(item.id, this.state.categorySelected) == -1 ? "e-outer-wrap e-seller e-wholesaler" : "e-outer-wrap e-seller e-wholesaler e-active" }

                  onClick={(e) => {

                    var tempArry = this.state.categorySelected;
                    var tempIndex = $.inArray(item.id, tempArry);
                    if(tempIndex == -1){
                      tempArry.push(item.id)
                    }
                    else{
                      tempArry.splice(tempIndex, 1);
                    }
                    this.setState({categorySelected: tempArry}) }} 
                  >
                    <span className="pl-4">{this.props.type=== 1? item.category: item.name}</span>
                  </div>
                </div>
              );
            })
          }
        </div>

        <div className="row mt-4">
          <div className="col-md-6 col-sm-8 col-10">
            <label>GST Number</label>
            <Input id="e-gst" value={this.state.gst} type="text" className="e-profile-edit" valueChange={(e) => {this.setState({gst: e}) }}/>
          </div>
          <div className="col-md-6">
            <label>Phone Number</label>
            <Input id="e-phone-no" value={this.state.phone} type="text" className="e-profile-edit" valueChange={(e) => {this.setState({phone: e}) }}/>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-md-6  col-8">
            <div>
              <label>Locality</label>
              {
                this.props.type === 1?
                <Input id="e-locality" value={this.state.locality} type="text" className="e-profile-edit" valueChange={(e) => {this.setState({locality: e}) }}/>
                :
                <SelectBox options={this.state.locationOptions} selectchange={(val)=>{this.setState({locality: val}); if(val.value===0) this.setState({searchLocation: true});}}/>
              }
              {
                this.state.searchLocation?
                <div className="pt-4">
                  <SelectBox options={this.state.newLocationOptions}
                   selectchange={(val)=>this.setState({newLocation: val})}
                   isSearchable={true}
                   inputValue={this.state.locationSearch}
                   onInputChange={(e) => this.search(e)}
                   placeholder="Search for your location"/>
                </div>
                :
                null
              }
            </div>
            <div className="mt-4">
              <label>Certificate of Incorporation</label>
              {
                this.state.certificate && this.state.certificate.length ?
                  <div className="e-upload-btn position-relative e-success">
                    Upload Success
                    <span valueChange={(e) => {this.setState({certificate: null}) }}></span>
                  </div>
                :
                  <div className="e-upload-btn" onClick={this.triggerClick.bind(this, "#e-certificate-upload")}>{this.state.showUploadLoader ? "Loading.." : "Upload"}</div>
              }
              <ImageUploader id="e-certificate-upload" uploadSuccess={this.certificateUploaded.bind(this)} uploadLoader={(e) => {this.setState({showUploadLoader: true}) }}/>
            </div>
          </div>
          <div className="col-md-6">
            <label>Address</label>
            <Textarea id="e-address" value={this.state.address} type="text" className="e-profile-edit" valueChange={(e) => {this.setState({address: e}) }}></Textarea>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <label>how did you hear about truekhoj?</label>
            <SelectBox options={options} selectchange={this.selectchange.bind(this)}/>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 e-signup-checkbox">
            <CheckBox label="By creating this account I agree to truekhoj business platform's" checked={this.state.termsCheck} onClick={this.toggleCheckbox.bind(this)}/>
            <a href="https://truekhoj.com/terms" target="_blank">Terms & conditions</a>
          </div>
        </div>

        {
          this.state.error.length || this.props.error ?
            <div className="row">
              <div className="col-12">
                {
                  this.props.error ?
                    <div className="e-error">{this.props.error}</div>
                  :
                    <div className="e-error">{this.state.error}</div>
                }
              </div>
            </div>
          :
            null
        }
        

        <div className="row">
          <div className="col-lg-12 mt-3">
            {
              this.state.termsCheck &&
              this.state.name && 
              this.state.mail &&
              this.state.categorySelected.length &&
              this.state.gst &&
              this.state.phone &&
              this.state.locality &&
              this.state.address &&
              this.state.certificate && 
              this.state.certificate.length ?
                <span className="e-signup-btn" onClick={this.buttonClick.bind(this)}>Next</span>
              :
                <span className="e-signup-btn e-in-active">Next</span>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default SignupTab2;
